export default {
  'cobinhood': 29200,
  'wandx': 910,
  'xyo': 33700,
  'ncash': 7350,
  'bitrewards': 173200,
  'singularitynet': 75,
  'autonio': 80,
  'credits': 275,
  'orbs': 700,
  'essentia': 3650,
  'moneynet': 38600
}



// WEBPACK FOOTER //
// ./src/components/data/fee.js